import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Button,
  CardComponent,
  ContractsTable,
  FileDropZone,
  PageTitleAndSubTitle,
  ReportsSelectionTable,
  TabStepper,
  TextField,
  Trash,
  TypableDropdown,
  UploadedDocument,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import Loader from '../../molecules/Loader';
import contractAIQConstants from '../../../core-utils/messages/ContractAIQConstants';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import TabSelection from '../../molecules/TabSelection';
import { useNavigate, useLocation } from 'react-router-dom';
import { scrollBarStyles } from '../../../core-utils/messages/CommonConstants';
import DownloadReportModal from '../../molecules/DownloadReportModal';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import axios from 'axios';
import properties from '../../../core-utils/properties';
import { useStores } from '../../../stores';
import { base64toByteArrayConverter } from '../../../core-utils/helper-utils/downloadPdfHelper';
import {
  bytesToMB,
  extractCompareAgreementDetails,
  formatContractReports,
  formatDraftReportData,
  formatDraftsData,
  getFeaturesByServiceAgreement,
  getReportsByServiceAgreement,
} from '../../../core-utils/helper-utils/contractAIQHelper';
import { DRAFT_SELECTED } from '../../../core-utils/routes';
import Snackbar from '../../atoms/Snackbar';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import contract from '../../../../public/Images/Contract.png';
import completion from '../../../../public/Images/Completion.png';
import GifWithLabels from '@HomaHealth/ui-component-library/lib/_patient-access-components/molecules/GIFWithLabels';
import {
  extractAndSaveMetadataForContract,
  extractAndSaveProvisionMatrix,
  getUrlsForServiceAgreement,
} from '../../../core-utils/helper-utils/contractMetadataHelper';
import { extractReport } from '../../../core-utils/helper-utils/contractReportHelper';
import InfoBar from '../../atoms/InfoBar';
import BasicModal from '../../atoms/BasicModal';
import NoDoc from '../../atoms/Icons/NoDocuments';

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  tabContent: { marginTop: '28px' },
  onboardingCards: {
    display: 'flex',
    gap: '24px',
  },
  groupDetails: {
    minWidth: '214px',
    background: patientAccessTheme.palette.status.white,
    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    borderTop: 'none',
    borderRadius: '4px',
  },
  detail: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    borderTop: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    padding: '18px 16px 18px 20px',
  },
  stepsGrid: {
    background: patientAccessTheme.palette.status.white,
    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    borderRadius: '4px',
    width: '100%',
  },
  contractsUpload: {
    padding: '25px 24px 28px 24px',
    height: '505px',
    position: 'relative',
  },
  uploadFilesGrid: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    marginBottom: '30px',
  },
  uploadedFiles: {
    height: '190px',
    width: '60%',
    background: patientAccessTheme.palette.background.default,
    borderRadius: '4px',
    padding: '18px 12px',
  },
  files: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    height: '136px',
    overflow: 'auto',
    paddingRight: '8px',
    ...scrollBarStyles,
  },
  contractLabels: {
    display: 'flex',
    marginBottom: '12px',
  },
  contractDocs: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    height: '308px',
    overflow: 'auto',
    paddingRight: '7px',
    ...scrollBarStyles,
  },
  contractsTable: {
    maxHeight: '336px',
    paddingRight: '4px',
    overflowY: 'auto',
    ...scrollBarStyles,
  },
  eachContractDoc: {
    display: 'flex',
    gap: '12px',
  },
  buttonsGrid: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    position: 'absolute',
    bottom: '24px',
    right: '24px',
  },
  completedState: {
    display: 'flex',
    alignItems: 'center',
    height: '505px',
    justifyContent: 'center',
    padding: '0px 200px',
  },
  tableHeader: {
    height: '48px',
    backgroundColor: patientAccessTheme.palette.grey[100],
    borderTop: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    '&:first-child': {
      paddingLeft: '38px',
    },
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  tableRow: {
    height: 'auto',
    minHeight: '56px',
    padding: '0px',
    borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    '& td:first-child': {
      paddingLeft: '26px',
    },
    '&:hover': {
      backgroundColor: patientAccessTheme.palette.grey[300],
    },
    display: 'flex',
    alignItems: 'center',
  },
  tableTHForRowTop: {
    height: '48px',
    backgroundColor: patientAccessTheme.palette.grey[100],
    borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
  },
  tableHeaderText: {
    fontWeight: 500,
    color: patientAccessTheme.palette.text.highemphasis,
    fontSize: '12px',
    lineHeight: '12px',
  },
  tableDataText: {
    fontSize: '14px',
    lineHeight: '24px',
    color: patientAccessTheme.palette.text.highemphasis,
    width: '244px',
    display: 'flex',
    alignItems: 'center',
    gap: '7px',
  },
  mergeTable: {
    padding: '0px',
  },
  ellipses: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '165px',
    whiteSpace: 'nowrap',
    '&:hover': {
      overflow: 'visible',
      whiteSpace: 'normal',
      height: 'auto',
    },
  },
  uploadModal: {
    width: '800px',
    maxHeight: '720px',
    backgroundColor: patientAccessTheme.palette.status.white,
    borderRadius: '8px',
    padding: '24px 32px 20px 32px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    flexDirection: 'column',
  },
  textfield: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  textfieldsGrid: {
    display: 'flex',
    gap: '28px',
    borderRadius: '8px',
    padding: '15px 25px 15px 25px',
    border: '1px solid' + patientAccessTheme.palette.grey[300],
    marginBottom: '20px',
  },
  noDataBottomCardContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '300px',
    gap: '20px',
  },
});

export interface locationProps {
  state: {
    tabIndex: number;
  };
}

export const DraftAgreementComponent = observer(() => {
  // Constants
  const { classes } = useStyles();
  const location: locationProps = useLocation();
  const navigate = useNavigate();
  const messages = contractAIQConstants.DRAFTS;
  const listTabs = ['All Reports', 'All Drafts'];
  const employerGroupStore = useStores().employerGroupStore;
  const employer =
    employerGroupStore.employerGroupResponseData.employer_group_name[0];
  const egNid = employerGroupStore.employerGroupResponseData.eg_nid[0];

  //   States
  const [loading, setLoading] = useState<boolean>(true);
  const [tabIndex, setTabIndex] = useState<number>(
    location?.state?.tabIndex ?? 0,
  );
  const [allDraftNames, setAllDraftNames] = useState<any>([]);

  // Upload Document states
  const [newDraftModel, setNewDraftModel] = useState<boolean>(false);
  const [draftName, setDraftName] = useState<string>('');
  const [draftNameError, setDraftNameError] = useState<any>('');
  const [
    draftServiceAgreementId,
    setDraftServiceAgreementId,
  ] = useState<string>('');
  const [selectedFiles, setSelectedFiles] = useState<any>([]);
  const [draftDocType, setDraftDocType] = useState<string>('Base Document');
  const [uploadedDocuments, setUploadedDocuments] = useState<any[]>([]);

  // Reports States
  const [contractLoading, setContractLoading] = useState<boolean>(false);
  const [reportsTableData, setReportsTableData] = useState<any>([]);
  const [downloadModalOpen, setDownloadModalOpen] = useState<boolean>(false);
  const [downloadRow, setDownloadRow] = useState<any>();
  const [downloadReportOptions, setDownloadReportOptions] = useState<any>([]);
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  // Drafts
  const [drafts, setDrafts] = useState<any>([]);
  const [draftsTableData, setDraftsTableData] = useState<any>([]);
  const [serviceAgreements, setServiceAgreements] = useState<any>([]);

  const [activeStep, setActiveStep] = useState<number>(0);
  const [completedSteps, setCompletedSteps] = useState<number[]>([]);

  //  Functions
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };
  const handleCloseSnackBar = () => {
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  // Upload Documents

  const areArraysEqualIgnoringOrder = (arr1: any, arr2: any) => {
    if (arr1?.length !== arr2?.length) {
      return false;
    }
    return arr1?.sort()?.join(',') === arr2?.sort()?.join(',');
  };

  const handleSaveReports = async (row: any) => {
    handleOpenSnackBar('Update draft reports is in progress', 'info', 2000);

    try {
      await addReports([row]);
      setReportsTableData((prevData: any) =>
        prevData.map((draft: any) =>
          draft.draft_id === row.draft_id ? { ...draft } : draft,
        ),
      );
      getAllDrafts();
      handleOpenSnackBar(
        'Contract Reports updated successfully',
        'success',
        2000,
      );
    } catch (error: any) {
      handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
    }
  };

  const handleReportSelectionChange = () => {
    const updatedReports = reportsTableData.map((item: any) => {
      const existingReports = drafts.find(
        (draft: any) => draft._id === item.draft_id,
      );
      return {
        ...item,
        showSave: !areArraysEqualIgnoringOrder(
          item.selectedReports,
          existingReports.reports,
        ),
      };
    });
    setReportsTableData(updatedReports);
  };

  const handleReportDownload = async (row: any) => {
    const reportMap: any = {
      'Gag Clause Prohibition Compliance Check': 'gagClauseReport',
      'Compensation Transparency Compliance Check':
        'compensationTransparencyReport',
      'Provision Matrix': 'provisionMatrixReport',
    };
    if (row.status === 'Ready') {
      const reportOptions = row.selectedReports.map((item: any) => {
        return {
          checked: false,
          report: item,
          reportIdentifier: reportMap[item] || '',
        };
      });
      setDownloadReportOptions(reportOptions);
      setDownloadRow(row);
      setDownloadModalOpen(true);
    } else {
      handleOpenSnackBar(
        'Report is not ready yet. Please try again later when the status is in Ready',
        'info',
        5000,
      );
    }
  };

  // Reports Functions
  const downloadReport = async () => {
    const selectedReport = downloadReportOptions.find(
      (item: any) => item.checked,
    ).reportIdentifier;
    setDownloadModalOpen(false);
    handleOpenSnackBar(
      'Report is being downloaded please wait...',
      'info',
      5000,
    );
    axios
      .post(
        properties.aiqBaseUrl + properties.downloadComplianceAssuranceReport,
        {
          draft_id: downloadRow.draft_id,
          employer: employer,
          reportName: selectedReport,
        },
      )
      .then((res) => {
        if (res) {
          const byteArray = base64toByteArrayConverter(res.data?.data);
          const file = new Blob([byteArray], {
            type: 'application/pdf;base64',
          });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL, '_blank');
          setDownloadRow(null);
          setDownloadReportOptions([]);
          handleOpenSnackBar('Report Downloaded Successfully', 'success', 5000);
        }
      })
      .catch((error) => {
        handleOpenSnackBar(
          error.response?.data?.error ?? 'Report Download Failed',
          'error',
          5000,
        );
      });
  };

  // Drafts Functions
  const handleRowMenuItemClick = async (row: any, menuItem: string) => {
    const { draft_id } = row;
    switch (menuItem) {
      case 'Delete':
        await axios.post(
          properties.aiqBaseUrl +
            properties.draftBaseUrl +
            properties.deleteDraft,
          {
            draft_id,
          },
        );
        getAllDrafts();
        break;
      default:
        break;
    }
  };

  const handleDraftOnClick = async (row: any) => {
    navigate(DRAFT_SELECTED, {
      state: {
        isDraft: true,
        isDocumentView: false,
        contract: row.type,
        draftName: row.name,
      },
    });
  };

  // Apis
  // Upload Report Api
  const uploadDocuments = async () => {
    setContractLoading(true);

    const formData = new FormData();
    // Append files to the form data
    selectedFiles.forEach((file: any) => {
      formData.append(`file`, file);
    });
    // Append other form data
    formData.append('employer', employer);
    formData.append('document_type', draftDocType);
    formData.append('eg_nid', egNid);
    formData.append('service_agreement_id', draftServiceAgreementId);
    formData.append('draft_name', draftName);

    await axios
      .post(
        properties.aiqBaseUrl +
          properties.draftBaseUrl +
          properties.createDraft,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then(async (res: any) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          const reports = getReportsByServiceAgreement(
            data?.service_agreement_id?.service_agreement_name,
          );
          const features = getFeaturesByServiceAgreement(
            data?.service_agreement_id?.service_agreement_name,
          );
          const updatedDocuments = [
            {
              name: data?.draft_name,
              draft_id: data?._id,
              type: data?.service_agreement_id?.service_agreement_name,
              features: [...reports, ...features],
              selectedFeatures: [
                ...(data?.reports ?? []),
                ...(data?.features ?? []),
              ],
              showSave: false,
            },
          ];
          setUploadedDocuments(updatedDocuments);
          setContractLoading(false);
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
        setContractLoading(false);
      });
  };
  const getServiceAgreements = async () => {
    setLoading(true);
    await axios
      .get(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getServiceAgreements,
      )
      .then((res: any) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          setServiceAgreements(data);
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
    setLoading(false);
  };

  const getAllDraftName = async () => {
    await axios
      .get(
        properties.aiqBaseUrl +
          properties.draftBaseUrl +
          properties.getAllDraftNames,
      )
      .then((res: any) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          setAllDraftNames(data);
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const addReports = async (data: any) => {
    const reportList = formatContractReports(data, reportsTableData, true);
    await axios
      .post(
        properties.aiqBaseUrl + properties.draftBaseUrl + properties.addReports,
        {
          reportList: reportList,
        },
      )
      .then((res: any) => {
        if (res?.status === 200) {
          const data = res?.data?.data;
          //report extraction for all base contracts
          Promise.all(
            data?.map(async (draft: any) => {
              const draft_id = draft._id;
              if (draft?.document_type === 'Base Document') {
                const documentUrl = draft?.document_url;
                if (draft?.features?.includes('Provision Matrix')) {
                  await extractAndSaveProvisionMatrix(
                    documentUrl,
                    '',
                    egNid,
                    draft?.service_agreement_id?.service_agreement_name,
                    draft_id,
                    true,
                  );
                }
                await Promise.all([
                  draft?.reports?.map(async (report: string) => {
                    const {
                      compareAgreementId,
                      compareUrl,
                    } = extractCompareAgreementDetails(data, report, true);

                    await extractReport(
                      '',
                      documentUrl,
                      report,
                      egNid,
                      compareAgreementId,
                      compareUrl,
                      draft_id,
                      true,
                    );
                  }),
                  extractAndSaveMetadataForContract(
                    egNid,
                    '',
                    draft?.service_agreement_id?.service_agreement_name,
                    draft?.document_url,
                    draft_id,
                    getUrlsForServiceAgreement(
                      draft?.service_agreement_id?.service_agreement_name,
                      draft?.features,
                    ),
                  ),
                ]);
              }
            }),
          );
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const getAllDrafts = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.draftBaseUrl +
          properties.getAllDrafts,
        { eg_nid: egNid },
      )
      .then((res: any) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          setDrafts(data);
          setReportsTableData(formatDraftReportData(data));
          setDraftsTableData(formatDraftsData(data));
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000);
      });
  };

  const apiCalls = async () => {
    setContractLoading(true);
    await getAllDrafts();
    setContractLoading(false);
  };

  // useEffects
  useEffect(() => {
    switch (tabIndex) {
      case 0:
        getServiceAgreements();
        getAllDraftName();
        break;
      case 1:
        apiCalls();
        break;
      case 2:
        apiCalls();
        break;
      default:
        break;
    }
  }, [tabIndex]);

  //All Components

  //Tabs Content components

  // Upload Document Tab
  const UploadDocumentsTab = () => {
    return (
      <Grid>
        <Grid className={classes.onboardingCards}>
          <Grid className={classes.stepsGrid}>
            <TabStepper
              steps={messages.UPLOAD_TABS}
              stepWidth="100%"
              activeStep={activeStep}
              handleStepOnClick={(index) => {
                setActiveStep(index);
              }}
              completedSteps={completedSteps}
            />
            {getStepContent()}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  //Reports Tab Component
  const ReportsTab = () => {
    return (
      <>
        {contractLoading ? (
          <Loader />
        ) : reportsTableData?.length > 0 ? (
          <>
            <CardComponent
              title={'All Reports'}
              titleSubTitleMargin="12px"
              body={
                <ReportsSelectionTable
                  rowsData={reportsTableData}
                  setRowsData={setReportsTableData}
                  columns={[
                    'Draft Name',
                    'Agreement Type',
                    'Status',
                    'Analysis/Reports',
                    '',
                    '',
                  ]}
                  showDownloadButton
                  showSaveButton
                  handleSaveButton={handleSaveReports}
                  handleShowSaveButton={handleReportSelectionChange}
                  handleDownloadButton={handleReportDownload}
                />
              }
              mainGridStyles={{ marginBottom: '20px' }}
            />
            {downloadModalOpen && (
              <DownloadReportModal
                open={downloadModalOpen}
                handleClose={() => {
                  setDownloadModalOpen(false);
                  setDownloadRow(null);
                  setDownloadReportOptions([]);
                }}
                handleDownload={downloadReport}
                options={downloadReportOptions}
                setOptions={setDownloadReportOptions}
                title={`Download Report for Draft - ${downloadRow.name}`}
              />
            )}
          </>
        ) : (
          <Grid className={classes.noDataBottomCardContainer}>
            <NoDoc />
            <Button
              label={'Upload PDF'}
              color="primary"
              width="auto"
              height="auto"
              onClick={() => {
                setNewDraftModel(true);
              }}
            />
          </Grid>
        )}
      </>
    );
  };

  // Drafts
  const DraftsTab = () => {
    return (
      <>
        {contractLoading ? (
          <Loader />
        ) : draftsTableData?.length > 0 ? (
          <CardComponent
            title={'All Draft Documents'}
            titleSubTitleMargin="12px"
            body={
              <ContractsTable
                rowsData={draftsTableData}
                columns={[
                  'Draft Name',
                  'Type of Service Agreement',
                  'Status',
                  'Uploaded Date',
                ]}
                showActionButtons={false}
                showRowMenu={true}
                rowMenuItems={[
                  {
                    label: 'Delete',
                    icon: <Trash />,
                  },
                ]}
                handleRowMenuItemClick={handleRowMenuItemClick}
                handleRowClick={handleDraftOnClick}
              />
            }
            mainGridStyles={{ marginBottom: '20px' }}
          />
        ) : (
          <Grid className={classes.noDataBottomCardContainer}>
            <NoDoc />
            <Button
              label={'Upload PDF'}
              color="primary"
              width="auto"
              height="auto"
              onClick={() => {
                setNewDraftModel(true);
              }}
            />
          </Grid>
        )}
      </>
    );
  };

  // get Tabs Component
  const getTabsContent = () => {
    switch (tabIndex) {
      // case 0:
      //   return UploadDocumentsTab();
      case 0:
        return ReportsTab();
      case 1:
        return DraftsTab();
      default:
        return <></>;
    }
  };

  const ContractCompleted = () => {
    return (
      <Grid className={classes.completedState}>
        <GifWithLabels
          mainLabel={
            <Typography
              fontSize="14px"
              fontType="medium"
              lineHeight="24px"
              textColor={patientAccessTheme.palette.text.highemphasis}
              margin="32px"
            >
              {activeStep === 0
                ? messages.COMPLETED_MESSAGE
                : messages.COMPLETED_MESSAGE1}
            </Typography>
          }
          subLabel={
            <Button
              label={activeStep === 0 ? 'Start Again' : 'Go to Drafts'}
              variant="contained"
              height="37px"
              width="auto"
              onClick={() => {
                if (activeStep === 0) {
                  getAllDraftName();
                  setSelectedFiles([]);
                  setCompletedSteps([]);
                  setDraftName('');
                  setDraftServiceAgreementId('');
                  setUploadedDocuments([]);
                } else {
                  setTabIndex(2);
                }
              }}
            />
          }
          gifUrl={activeStep === 0 ? contract : completion}
        />
      </Grid>
    );
  };
  const UploadFiles = (
    uploadedFiles: any[],
    setUploadedFiles: React.Dispatch<any>,
  ) => {
    return (
      <>
        <Grid className={classes.uploadFilesGrid}>
          {uploadedFiles?.length > 0 && (
            <Grid className={classes.uploadedFiles}>
              <Grid style={{ display: 'flex', gap: '28px' }}>
                <Grid style={{ width: '60%' }}>
                  <Typography
                    fontSize="12px"
                    fontType="regular"
                    lineHeight="24px"
                    textColor={patientAccessTheme.palette.text.lowemphasis}
                    margin="0px 0px 16px 0px"
                  >
                    {`${uploadedFiles?.length} Document${
                      uploadedFiles?.length > 1 ? 's' : ''
                    } uploaded`}
                  </Typography>
                </Grid>
                <Typography
                  fontSize="12px"
                  fontType="regular"
                  lineHeight="24px"
                  textColor={patientAccessTheme.palette.text.lowemphasis}
                  margin="0px 0px 16px 0px"
                >
                  {messages.DOC_TYPE}
                </Typography>
              </Grid>
              <Grid className={classes.files}>
                {uploadedFiles?.map((item: any, index: number) => {
                  return (
                    <Grid style={{ display: 'flex', gap: '28px' }}>
                      <UploadedDocument
                        name={item?.name}
                        size={`${bytesToMB(item?.size)} MB`}
                        handleDelete={() => {
                          const updatedItems = [...uploadedFiles];
                          // Remove the item at the specified index
                          updatedItems.splice(index, 1);
                          // Update the state with the new array
                          setUploadedFiles(updatedItems);
                        }}
                        width="60%"
                        truncateWidth="230px"
                      />
                      <TypableDropdown
                        placeholder={'Select'}
                        dropDownOptions={messages.DOC_TYPE_OPTIONS}
                        dropDownValues={messages.DOC_TYPE_OPTIONS}
                        value={draftDocType}
                        handleChange={(event) =>
                          setDraftDocType(event.target.value as string)
                        }
                        height="40px"
                        width="200px"
                        handleInputChange={() => {}}
                        hideTextField={true}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          )}
          <FileDropZone
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            filesSupported={['.pdf']}
            width={uploadedFiles?.length > 0 ? '38%' : '100%'}
            height="190px"
            isMultiple={false}
            title="Drag or drop a file here"
          />
        </Grid>
        <InfoBar info={messages.UPLOAD_INFO} type="Info" width="100%" />
      </>
    );
  };

  const ContractsUpload = () => {
    return (
      <>
        {contractLoading ? (
          <Loader height="505px" />
        ) : (
          <Grid className={classes.contractsUpload}>
            <Grid className={classes.textfieldsGrid}>
              <Grid className={classes.textfield}>
                <Typography
                  fontSize="14px"
                  fontType="semiBold"
                  lineHeight="24px"
                  textColor={patientAccessTheme.palette.text.highemphasis}
                >
                  {messages.DRAFT_NAME}
                </Typography>
                <TextField
                  width="400px"
                  height="36px"
                  placeholder={`Enter Project Name`}
                  value={draftName}
                  onChange={(event: any) => {
                    const newDraftName = event.target.value;
                    setDraftName(newDraftName);
                    const isDuplicate = allDraftNames.some(
                      (name: any) =>
                        name.toLowerCase().trim() ===
                        newDraftName.toLowerCase().trim(),
                    );
                    if (isDuplicate) {
                      setDraftNameError('The draft name already exists.');
                    } else {
                      setDraftNameError('');
                    }
                  }}
                  error={Boolean(draftNameError)}
                  helperText={draftNameError}
                />
              </Grid>
              <Grid className={classes.textfield}>
                <Typography
                  fontSize="14px"
                  fontType="semiBold"
                  lineHeight="24px"
                  textColor={patientAccessTheme.palette.text.highemphasis}
                >
                  {messages.AGREEMENT_TYPE}
                </Typography>
                <TypableDropdown
                  placeholder={'Select'}
                  dropDownOptions={serviceAgreements?.map(
                    (item: any) => item?.service_agreement_name,
                  )}
                  dropDownValues={serviceAgreements?.map(
                    (item: any) => item?._id,
                  )}
                  value={draftServiceAgreementId}
                  handleChange={(event) =>
                    setDraftServiceAgreementId(event.target.value as string)
                  }
                  height="40px"
                  width="400px"
                  handleInputChange={() => {}}
                  hideTextField={true}
                />
              </Grid>
            </Grid>
            {UploadFiles(selectedFiles, setSelectedFiles)}
            <Grid className={classes.buttonsGrid}>
              <Button
                label={messages.UPLOAD_CONTRACT}
                variant="contained"
                height="37px"
                width="auto"
                disabled={
                  selectedFiles?.length === 0 ||
                  !draftName ||
                  !draftServiceAgreementId ||
                  !draftDocType ||
                  Boolean(draftNameError)
                }
                onClick={async () => {
                  await uploadDocuments();
                  setCompletedSteps((prevSteps) => [...prevSteps, 0]);
                  setActiveStep(1);
                }}
              />
            </Grid>
          </Grid>
        )}
      </>
    );
  };

  const ReportSelection = () => {
    return (
      <>
        {uploadedDocuments?.length > 0 && (
          <Grid className={classes.contractsUpload}>
            <ReportsSelectionTable
              rowsData={uploadedDocuments}
              setRowsData={setUploadedDocuments}
              columns={['Draft Name', 'Agreement Type', 'Analysis/Reports']}
            />
            <Grid className={classes.buttonsGrid}>
              <Button
                label={messages.GENERATE_REPORT}
                variant="contained"
                height="37px"
                width="auto"
                disabled={
                  !uploadedDocuments.some(
                    (doc) =>
                      doc?.selectedReports?.length > 0 ||
                      doc?.selectedFeatures?.length > 0,
                  )
                }
                onClick={async () => {
                  await addReports(uploadedDocuments);
                  setCompletedSteps((prevSteps) => [...prevSteps, 1]);
                }}
              />
            </Grid>
          </Grid>
        )}
      </>
    );
  };

  const getStepContent = () => {
    switch (activeStep) {
      case 0:
        return completedSteps?.includes(0) ? (
          <ContractCompleted />
        ) : (
          ContractsUpload()
        );
      case 1:
        return completedSteps?.includes(1) ? (
          <ContractCompleted />
        ) : (
          ReportSelection()
        );
      default:
        return <></>;
    }
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Grid className={classes.root}>
          <PageTitleAndSubTitle
            title={messages.TITLE}
            subTitle={messages.SUB_TITLE}
            customButton
            customButtonText="Upload PDF"
            customButtonVariant="contained"
            customButtonClick={() => {
              setNewDraftModel(true);
            }}
          />
          <TabSelection
            selectedTabIndex={tabIndex}
            setSelectedTabIndex={setTabIndex}
            tabList={listTabs}
          />
          <Grid className={classes.tabContent}>{getTabsContent()}</Grid>
        </Grid>
      )}
      <BasicModal
        open={newDraftModel}
        children={UploadDocumentsTab()}
        title={'New Draft'}
        isSaveButton={false}
        handleClose={() => setNewDraftModel(false)}
        width="1000px"
        height="550px"
        isScrollable={true}
        isCloseBtn={false}
      />
      <Snackbar
        {...snackbarState}
        vertical={'bottom'}
        horizontal={'right'}
        handleClose={handleCloseSnackBar}
      />
    </>
  );
});
